<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="1000px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  data-vv-as="Nombre"
                  label="Nombre*"
                  name="name"
                  v-model="item.name"
                  v-validate="'required'"
                  :disabled="isViewModal()"
                ></v-text-field>
                <span class="red--text caption">{{ errors.first("name") }}</span>
              </v-col>

              <v-col cols="12" md="3">
                <v-combobox
                  v-model="item.emitter"
                  data-vv-as="emisor"
                  name="emitter"
                  item-text="name"
                  item-value="id"
                  :items="emitters"
                  label="Emisor*"
                  :disabled="isViewModal()"
                  autocomplete="off"
                  clearable
                  v-validate="'required|combobox_required'"
                ></v-combobox>
                <span class="red--text caption">{{ errors.first("emitter") }}</span>
              </v-col>

              <v-col cols="12" md="3">
                <v-combobox
                  v-model="item.clase_comprobante"
                  data-vv-as="tipo de comprobante"
                  name="clase_comprobante"
                  item-text="name"
                  item-value="id"
                  :items="clases_comprobante"
                  label="Tipo de Comprobante"
                  :disabled="isViewModal()"
                  autocomplete="off"
                  clearable
                ></v-combobox>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="item.reference"
                  label="Referencia"
                  autocomplete="off"
                  :disabled="isViewModal()"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="item.concept"
                  label="Concepto"
                  :placeholder="isViewModal() ? '' : 'Describa el motivo general del movimiento...'"
                  autocomplete="off"
                  :disabled="isViewModal()"
                ></v-text-field>
              </v-col>
            </v-row>

            <div class="d-flex justify-space-between align-center mt-3 mb-3">
              <div class="d-flex align-center">
                <v-icon color="#1565C0" class="mr-2" size="20">format_list_bulleted</v-icon>
                <span class="subtitle-1 font-weight-bold grey--text text--darken-3">Detalles</span>
              </div>
              <v-btn v-if="!isViewModal()" color="primary" small @click="addDetail">
                <v-icon small left>add</v-icon>
                Agregar Item
              </v-btn>
            </div>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="detail-th">#</th>
                    <th class="detail-th">Cuenta</th>
                    <th class="detail-th">Centro / Concepto</th>
                    <th class="detail-th">Descripción</th>
                    <th class="detail-th" v-if="!isViewModal()"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(detail, idx) in item.details" :key="idx">
                    <td class="text-center grey--text text--darken-1" style="min-width:40px; font-size:13px; font-weight:500">
                      {{ String(idx + 1).padStart(2, '0') }}
                    </td>
                    <td style="min-width:190px">
                      <v-combobox
                        v-model="detail.money_account"
                        item-text="name"
                        item-value="id"
                        :items="money_accounts"
                        hide-details
                        :disabled="isViewModal()"
                        class="py-1"
                      ></v-combobox>
                    </td>
                    <td style="min-width:160px">
                      <ConceptoCentroPicker
                        v-if="detail.money_account && detail.money_account.is_resultado"
                        :concepto.sync="detail.concepto"
                        :cost_center.sync="detail.cost_center"
                        :conceptos="conceptos"
                        :cost_centers="cost_centers"
                        :disabled="isViewModal()"
                        :inTable="true"
                      />
                      <span v-else class="grey--text caption">—</span>
                    </td>
                    <td style="min-width:200px">
                      <v-text-field
                        v-model="detail.description"
                        placeholder="Motivo de la línea..."
                        hide-details
                        :disabled="isViewModal()"
                        class="py-1"
                      ></v-text-field>
                    </td>
                    <td v-if="!isViewModal()" style="width:40px">
                      <v-icon color="red lighten-1" small @click="removeDetail(idx)">delete</v-icon>
                    </td>
                  </tr>
                  <tr v-if="item.details.length === 0">
                    <td colspan="5" class="text-center grey--text py-4">Sin detalles — hacé click en "Agregar Item"</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/sections";
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import ConceptoCentroPicker from "@/components/ConceptoCentroPicker.vue";

export default {
  mixins: [ModalGenericMixin],
  components: { ConceptoCentroPicker },
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      money_accounts: [],
      conceptos: [],
      cost_centers: [],
      clases_comprobante: [],
      emitters: [],
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog(val) {
      this.errors.clear();
      if (val) this.loadMoneyAccounts();
    },
    "item.emitter"() {
      this.loadMoneyAccounts();
    },
  },
  mounted() {
    this.loadComboData();
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    addDetail() {
      this.item.details.push({
        money_account: null,
        concepto: null,
        cost_center: null,
        description: null,
      });
    },
    removeDetail(idx) {
      this.item.details.splice(idx, 1);
    },
    loadMoneyAccounts() {
      const param = {};
      if (this.item.emitter && this.item.emitter.id) {
        param.emitter = { id: this.item.emitter.id };
      }
      generalService.setSection(Constant.SECTION_MONEY_ACCOUNTS);
      generalService.filter(param).then((r) => { this.money_accounts = r.result; }).catch(() => {});
    },
    loadComboData() {
      this.loadMoneyAccounts();

      generalService.setSection(Constant.SECTION_CONCEPTOS);
      generalService.filter().then((r) => { this.conceptos = r.result; }).catch(() => {});

      generalService.setSection(Constant.SECTION_COSTS_CENTERS);
      generalService.filter().then((r) => {
        this.cost_centers = r.result.map((cc) => ({ id: cc.id, name: cc.name }));
      }).catch(() => {});

      generalService.setSection(Constant.SECTION_TESORERIA_CLASE_COMPROBANTE);
      generalService.filter().then((r) => { this.clases_comprobante = r.result; }).catch(() => {});

      emmiterService.filter({ enabled: true }).then((r) => {
        this.emitters = r.result;
        if (this.emitters.length === 1 && !this.item.emitter) {
          this.item.emitter = this.emitters[0];
        }
      }).catch(() => {});
    },
    createItem(e) {
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();
          this.loading = true;
          const data = {
            id:                 this.item.id,
            name:               this.item.name,
            concept:            this.item.concept,
            reference:          this.item.reference,
            clase_comprobante:  this.item.clase_comprobante ? { id: this.item.clase_comprobante.id } : null,
            emitter:            this.item.emitter ? { id: this.item.emitter.id } : null,
            details: this.item.details.map((d) => ({
              money_account: d.money_account ? { id: d.money_account.id } : null,
              concepto:      d.concepto ? { id: d.concepto.id } : null,
              cost_center:   d.cost_center ? { id: d.cost_center.id } : null,
              description:   d.description,
            })),
          };

          const request = this.item.id > 0 ? this.service.update(data) : this.service.create(data);
          request
            .then((r) => {
              if (r.status) {
                this.$toast.success(
                  "La " + this.modal_title + (this.item.id > 0 ? " se modificó correctamente." : " se creó correctamente."),
                  "OK"
                );
                this.$emit("loadList");
                this.$emit("updateDialog", false);
              } else {
                this.$toast.error(r.msg, "Error");
              }
            })
            .catch(() => { this.$toast.error("Error al guardar.", "Error"); })
            .finally(() => { this.loading = false; });
        }
      });
    },
  },
};
</script>

<style scoped>
.detail-th {
  background-color: #F5F5F5 !important;
  color: #616161 !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
</style>
